import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(
  (theme) => ({
    title: {
      fontSize: '16px',
      fontWeight: 400,
      color: '#313131',
    },
    description: {
      color: '#313131',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '125.705%',
      whiteSpace: 'pre-line', // This allows line breaks to work
    },
  }),
  { name: 'PopoverTooltip' },
);

export default useStyles;
